export function getModel(objModel, zoom) {
	switch (+zoom) {
		case -1:
			objModel.obj = '/bim/-1f.obj';
			objModel.mtl = '/bim/-1f.mtl';
			objModel.position = [0, 0, 0];
			break;
		case 1:
			objModel.obj = '/bim/1f.obj';
			objModel.mtl = '/bim/1f.mtl';
			objModel.position = [0, 0, 0];
			break;
		case 2:
			objModel.obj = '/bim/2f.obj';
			objModel.mtl = '/bim/2f.mtl';
			objModel.position = [0, 0, 0];
			break;
		case 3:
			objModel.obj = '/bim/3f.obj';
			objModel.mtl = '/bim/3f.mtl';
			objModel.position = [0, 0, 0];
			break;
		case 4:
			objModel.obj = '/bim/4f.obj';
			objModel.mtl = '/bim/4f.mtl';
			objModel.position = [0, 0, 0];
			break;
		case 5:
			objModel.obj = '/bim/5f.obj';
			objModel.mtl = '/bim/5f.mtl';
			objModel.position = [0, 0, 0];
			break;
		default:
			objModel.obj = '/bim/简化.obj';
			objModel.mtl = '/bim/简化.mtl';
			objModel.position = [0, 0, 0];
			break;
	}
}
export const spotTypeName = {
	1: {
		name: '消防栓',
		obj: '/bim/消防栓.obj',
		mtl: '/bim/消防栓.mtl'
	},
	2: {
		name: '烟感',
		obj: '/bim/烟感.obj',
		mtl: '/bim/烟感.mtl'
	},
	3: {
		name: '灭火器',
		obj: '/bim/灭火器.obj',
		mtl: '/bim/灭火器.mtl'
	},

}
